import { axiosInstanceAutomatedBilling } from "../axios";
import {
  ApplicationCreate,
  ApplicationCreations,
  RequestResponse
} from "../types";

export const getApplication = async (id: number): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceAutomatedBilling.get(
      `/api/v1/application/${id}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    console.error("Unable to fetch application: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const getApplications: (
  pageNumber: number,
  pageSize: number
) => Promise<
  RequestResponse<{ records: ApplicationCreations[]; total: number }>
> = async (pageNumber, pageSize) => {
  try {
    const response = await axiosInstanceAutomatedBilling.get(
      "/api/v1/application/details",
      {
        params: { pageNumber, pageSize }
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data.applications,
        total: response.data.data.totalCount
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch applications: ", { err });
    return {
      error: true,
      message: err.response.data?.message || err.message || err,
      data: null
    };
  }
};

export const updateApplication = async (
  id: number,
  payload: ApplicationCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceAutomatedBilling.put(
      `/api/v1/application/${id}`,
      updatedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to update application: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const createApplication = async (
  payload: ApplicationCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceAutomatedBilling.post(
      `/api/v1/application/create`,
      payload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to create application: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
